<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <div class="pa-5 mt-5">
          <h2 class="headline text-center justify-center">お問い合わせ</h2>
            <p class="text-center mb-5">ご不明な点がございましたら、お気軽にお問い合わせください。</p>
            <div id="hubspot-form-container"></div>
         </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ContactPage',
  mounted() {
    // コンポーネントがマウントされた後にHubSpotフォームをロード
    this.loadHubspotForm();
  },
  methods: {
    loadHubspotForm() {
      // HubSpotのグローバルスクリプトが読み込まれているかを確認
      if (window.hbspt) {
        // フォームを生成する前に、既存のフォームをクリア（念のため）
        const container = document.getElementById('hubspot-form-container');
        if (container) {
          container.innerHTML = '';
          window.hbspt.forms.create({
            portalId: "21606187",
            formId: "07bd9ce7-20e6-4b81-8d0c-f94bb11e9f6e",
            region: "na2",
            target: "#hubspot-form-container" // 明示的にターゲットを指定
          });
        }
      } else {
        // HubSpotスクリプトがまだ読み込まれていない場合は、ここで読み込む
        // この処理は、public/index.html でグローバルに読み込む場合は不要になることが多いですが、
        // 念のためフォールバックとして残しておきます。
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = '//js-na2.hsforms.net/forms/embed/v2.js';
        script.addEventListener('load', () => {
          if (window.hbspt) {
            const container = document.getElementById('hubspot-form-container');
            if (container) {
              container.innerHTML = '';
              window.hbspt.forms.create({
                portalId: "21606187",
                formId: "07bd9ce7-20e6-4b81-8d0c-f94bb11e9f6e",
                region: "na2",
                target: "#hubspot-form-container"
              });
            }
          }
        });
        document.head.appendChild(script);
      }
    }
  },
};
</script>

<style scoped>
/* 必要に応じてスタイルを追加 */
.headline {
  font-size: 2.25rem !important; /* Vuetify default headline adjustment */
  font-weight: 500;
  line-height: 2.5rem;
  letter-spacing: normal !important;
}
</style>